/**
 * Formato de dinero con el prefijo de moneda de la instalación (p. ej. "RD$").
 * PURO. Mismo formato que la ficha de despacho: separador de miles en-US.
 */
export function money(value: number | null | undefined, prefix: string): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return `${prefix}${value.toLocaleString('en-US')}`;
}
